module.exports = __webpack_public_path__ + "img/transfer-icon-modal.d93daf37.svg";